import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignedIn, SignedOut, useUser } from '@gadgetinc/react';
import Index from '../routes/index';

const SignedInRedirect = () => {
  const navigate = useNavigate();
  const user = useUser();

  useEffect(() => {
    console.log('[RootPageHandler] User signed in, redirecting to /', { userId: user?.id });
    navigate('/', { replace: true });
  }, [navigate, user]);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Redirecting to dashboard...</p>
    </div>
  );
};

const RootPageHandler = () => {
  const user = useUser();
  
  console.log('[RootPageHandler] Rendering, user state:', { 
    hasUser: !!user, 
    userId: user?.id,
    userEmail: user?.email 
  });
  
  return (
    <>
      <SignedOut>
        <Index />
      </SignedOut>
      <SignedIn>
        <SignedInRedirect />
      </SignedIn>
    </>
  );
};

export default RootPageHandler;